function getCoords(e) {
    var t = e.getBoundingClientRect();
    return {
        top: t.top + pageYOffset,
        left: t.left + pageXOffset
    }
}

window.onload = function() {
    var r = window.innerHeight
      , m = document.querySelectorAll(".gs_reveal")
      , f = [];
    m.forEach(function(e) {
        f.push(getCoords(e).top)
    }),
    getAnimate()
    window.addEventListener("scroll", function() {
    	getAnimate()
    })
    function getAnimate() {
    	for (var e = window.scrollY, t = e + r, o = e + r / 1.2, n = 0; n < f.length; n++)
            o > f[n] && (m[n].classList.add("animate-done"),
            f.slice(n, 1));
    }
}


const burger = document.querySelector(".icon-burger");
const menu = document.querySelector(".js-menu");
const close = document.querySelector(".close-menu");

function closeMenu() {
    menu.classList.remove("open");
    document.body.classList.remove('fixed');
}
burger.onclick = function(){
  menu.classList.add("open");
  document.body.classList.add('fixed');
}

close.onclick = function(){
  closeMenu()
}


const anchors = document.querySelectorAll('a[href*="#"]')

for (let anchor of anchors) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()
    closeMenu()
    const blockID = anchor.getAttribute('href').substr(1)
    
    document.getElementById(blockID).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  })
}

// let open_modal = document.querySelectorAll('.open-modal');
// let modal_bg = document.querySelector('.modal-bg');
// let close_modal = document.getElementById('close-modal');
// let modal = document.getElementById('subscribe');
let body = document.getElementsByTagName('body')[0];
let observer = ScrollTrigger.normalizeScroll(true);


$('.open-modal').click(function(){
    observer.disable();
    closeMenu()
    $('.modal-bg').addClass('modal_vis');
    $('#subscribe').fadeIn(1000)
    $('body').addClass('fixed')
});

$('.close-modal').click(function(){
    $('.modal__info').show()
    $('.modal__done').hide()
    $('#subscribe').fadeOut()
    $('.modal-bg').removeClass('modal_vis');
    $('body').removeClass('fixed')
});

$(function () {
  $('[data-wamf-var]').on('click', function () {
    if (!window.wamf || !window.wamf.push || !window.wamf.send) {
      return true;
    }
    console.log($(this).data('wamf-var'));
    window.wamf.push($(this).data('wamf-var'), 'Yes');
    window.wamf.send();
  });
});